module.exports = __webpack_public_path__ + "img/icon-zalo@2x.3d9935a8.png";